// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./aboutPhotoEmpty.png");
var dir = previousRequest.replace("aboutPhotoEmpty.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "aboutPhotoEmpty.png",
	name: "aboutPhotoEmpty",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/aboutPhotoEmpty.png
// module id = 31
// module chunks = 4